<!-- section template -->
<template>
  <el-dialog :visible.sync="dialog2MixinVisible" width="˙786px" append-to-body :custom-class="`${$style.dialogScheduleItemServiceTime} isStyleBase`" @closed="$Dialog2MixinOnDestroy">
    <div class="dialogScheduleItemServiceTime__title mb-4">選擇預約的日期與時段</div>

    <el-scrollbar style="height: 500px; margin-bottom: 20px">
      <v-date-picker
        ref="dialogScheduleDate"
        v-model="defaultValue.date"
        v-loading="$isLoading('fetchReservationCalendar')"
        class="isStyleBase"
        :class="{ isStyleDingBeauty: $globalIsDingBeauty, 'not-touch': isFetchingReservation }"
        :min-date="new Date()"
        :disabled-dates="[
          {
            weekdays: getDefaultReservationDisabledDayList({ storeAlias: defaultValue.storeAlias, prepaidId: defaultValue.prepaidOrderUuid, type: 'v-date-picker' }),
          },
          ...currentDisabledDate,
        ]"
        is-expanded
        :masks="{ title: 'YYYY年 MM月' }"
        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
        @update:from-page="onChangePage"
        @input="onChangeDate"
      >
      </v-date-picker>
      <el-skeleton :loading="$isLoading('fetchReservationItem')" animated :throttle="0" style="margin-bottom: 3rem">
        <template slot="template">
          <div class="row" :class="[$style.skeletonList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
            <div v-for="n in 16" :key="n" class="col-3 skeletonList__item">
              <el-skeleton-item class="skeletonList__button" variant="rect" />
            </div>
          </div>
        </template>
        <template>
          <template v-if="!defaultValue.date">
            <span style="padding-bottom: 30px"> *請選擇時間 </span>
          </template>
          <template v-else-if="timeList.length === 0">
            <span style="padding-bottom: 30px"> *無時段可供預約，請選擇其他日期 </span>
          </template>
          <template v-else>
            <InputRadioTime v-model="defaultValue.time" :time-list="timeList" :display="16" @click="onChangeTime" />
          </template>
        </template>
      </el-skeleton>
    </el-scrollbar>

    <div class="button-wrapper">
      <BaseButton class="isStyleDark isOutline3 isFull" :class="{ isRadius: $globalIsJtails }" @click="dialog2MixinVisible = false"> 取消 </BaseButton>
      <BaseButton :disabled="!defaultValue.time || !defaultValue.date" class="isStylePrimary isFull" :class="{ isRadius: $globalIsJtails }" @click="onSubmit"> 確認 </BaseButton>
    </div>
  </el-dialog>
</template>
<script>
import dialog2Mixin from '../mixins/dialog2'
import formatDate from '@utils/format-date'
import isCondition from '@utils/is-condition'
import { authComputed } from '@store/helpers'
import { getStoreOption } from '@utils/ipetbooking-options'
import { getDefaultReservationDisabledDayList } from '@utils/ipetbooking-get-default'
import _debounce from 'lodash/debounce'
import { reservationTimeList } from '@utils/ipetbooking-reservation'
import getISODay from 'date-fns/getISODay'
import parseISO from 'date-fns/parseISO'
import lastDayOfMonth from 'date-fns/lastDayOfMonth'
import isThisMonth from 'date-fns/isThisMonth'
import isThisYear from 'date-fns/isThisYear'

export default {
  name: 'DialogScheduleService2',
  components: {
    InputRadioTime: () => import('@components/Input/InputRadioTime'),
  },
  mixins: [dialog2Mixin],
  data() {
    return {
      scheduleItem: {},
      reservationItemTimes: [],
      defaultValue: {
        time: '',
      },
      startDate: '',
      endDate: '',
      currentDisabledDate: [],
      type: '',
      callbackChangeSchedule: () => {},
      serviceType: 'cosmetic',
      isFetchingReservation: false,
    }
  },
  computed: {
    ...authComputed,
    storeItem() {
      return getStoreOption({
        value: this.defaultValue.storeAlias,
        type: 'item',
      })
    },
    buttonBarList() {
      const buttonBarList = [
        {
          text: this.formatMobileSubmitText,
          class: 'flex-grow-1',
          buttonClass: this.$globalIsDingBeauty ? 'isStylePrimary isSmall isFull' : 'isStylePrimary isRadius isSmall isFull',
          isLoading: this.loading,
          isDisabled: this.invalid,
          onClick: () => {
            this.onSubmit()
          },
        },
      ]

      return buttonBarList.filter((item) => {
        return isCondition(item)
      })
    },
    timeList() {
      return reservationTimeList({
        date: this.defaultValue?.date,
        storeAlias: this.storeItem.alias,
        times: this.reservationItemTimes,
        storeType: this.storeItem.storeType,
      })
    },
  },
  watch: {
    startDate: {
      immediate: true,
      handler(newValue, oldValue) {
        this.tryToFetchReservationCalendar()
      },
    },
    '$route.name': {
      handler: function (search) {
        if (search !== this.type) {
          this.dialog2MixinVisible = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const parameterValue = urlSearchParams.get('date')
    if (parameterValue) {
      this.defaultValue.date = parameterValue
      this.onChangeDate()
    }
  },
  methods: {
    formatDate,
    getDefaultReservationDisabledDayList,

    async onSubmit() {
      if (this.isLoggedIn) {
        await this.tryToStoreCart()
        this.goReservationCheckout()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin() {},
        })
      }
      this.$Dialog2MixinOnDestroy()
    },

    goReservationCheckout() {
      this.$router.push({
        name: 'add-reservation',
        params: {
          reservationAlias: this.defaultValue.reservationAlias,
        },
        query: {
          usePrepaid: this.$route.name == 'prepaid-reservation',
        },
      })
    },

    async tryToStoreCart() {
      const alias = this.defaultValue.reservationAlias
      const inventoryAlias = `${formatDate(this.defaultValue.date, 'yyyy-MM-dd')} ${this.defaultValue.time}`
      const scheduleItemIds = this.scheduleItem.id ? [this.scheduleItem.id] : []
      await this.$store.dispatch('cart/storeCart', { inventoryAlias, params: [{ alias, qty: 1 }], scheduleItemIds }).then(() => {
        return true
      })
    },

    onChangeDate: _debounce(function (item) {
      if (!this.defaultValue.date) return
      this.tryToFetchReservationItem()
    }, 300),

    tryToFetchReservationItem() {
      this.isFetchingReservation = true
      this.$store
        .dispatch('merchant/fetchReservationItem', {
          reservationAlias: this.defaultValue.reservationAlias,
          date: formatDate(this.defaultValue.date, 'yyyy-MM-dd'),
          prepaidOrderUuid: this.defaultValue.prepaidOrderUuid,
          scheduleItemId: this.scheduleItem.id,
          types: [this.serviceType],
        })
        .then(({ items }) => {
          this.isFetchingReservation = false
          const setReservationItemTimes = () => {
            const timesInfo = Object.keys(items.timesInfo).length
              ? Object.keys(items.timesInfo).filter((item) => {
                  return items.timesInfo[item].canTimeOrder
                })
              : []
            this.reservationItemTimes = timesInfo
            this.reservationScheduleItems = items.timesInfo
            this.checkOnlyOneTimesAutoFocus()
          }

          setReservationItemTimes()
          this.checkTimeInReservationItemTimes()
        })
    },

    checkTimeInReservationItemTimes() {
      const isIncludesTimes = this.reservationItemTimes.includes(this.defaultValue.time)

      if (!isIncludesTimes) {
        this.defaultValue.time = ''
      }
    },
    checkOnlyOneTimesAutoFocus() {
      if (this.timeList.length === 1) {
        this.defaultValue.time = this.timeList[0]
      }
    },
    onChangeTime() {
      // this.replaceHistory();
    },
    onChangePage: _debounce(function (page) {
      this.formatCalendarRangeDate(page)
    }, 300),
    formatCalendarRangeDate(page) {
      const date = new Date(page.year, page.month - 1)
      const isThisCurrentYear = isThisYear(date)
      const isThisCurrentMonth = isThisMonth(date)
      if (isThisCurrentYear && isThisCurrentMonth) {
        this.startDate = formatDate(new Date(), 'yyyy-MM-dd')
        this.endDate = formatDate(lastDayOfMonth(new Date()), 'yyyy-MM-dd')
      } else {
        this.startDate = formatDate(date, 'yyyy-MM-dd')
        this.endDate = formatDate(lastDayOfMonth(date), 'yyyy-MM-dd')
      }
    },
    tryToFetchReservationCalendar() {
      if (!this.startDate && !this.endDate) {
        return
      }
      const submitData = {
        startDate: this.startDate,
        endDate: this.endDate,
        priceAlias: this.defaultValue.reservationAlias,
        scheduleItemId: this.scheduleItem.id,
        types: [this.serviceType],
      }
      this.$store
        .dispatch('merchant/fetchReservationCalendar', {
          ...submitData,
        })
        .then(({ items }) => {
          const currentDisabledDate = Object.keys(items).length
            ? Object.keys(items).filter((item) => {
                return !items[item].isOpen
              })
            : []
          this.currentDisabledDate = currentDisabledDate.length
            ? currentDisabledDate.map((item) => {
                return parseISO(item)
              })
            : []
        })
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.dialogScheduleItemServiceTime {
  :global {
    .button-wrapper {
      display: flex;
      gap: 10px;
    }

    .not-touch {
      pointer-events: none;
    }

    .dialogScheduleItemServiceTime {
      &__title {
        margin-bottom: 1.5rem;
        font-family: $font-title;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary-dark;
        text-align: center;
      }

      &__content {
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;
        text-align: center;
      }
    }
  }
}
.skeletonList {
  margin-right: -0.25rem;
  margin-bottom: 5px;
  margin-left: -0.25rem;
  opacity: 0.5;

  :global {
    .skeletonList {
      &__item {
        padding-right: 0.25rem;
        padding-left: 0.25rem;
        margin-bottom: 5px;
      }

      &__button {
        height: 40px;
        border-radius: 10px;

        @include max-lg {
          height: 35px;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    .skeletonList {
      &__button {
        border-radius: 0;
      }
    }
  }
}

@media (min-width: 768px) {
  .dialogScheduleItemServiceTime {
    margin-top: 10vh;
  }
}
</style>
